import { FC, useEffect, useState } from "react";
import { isExpressWork } from "../../../../slices/works-slice";
import { WorkDTO } from "../../../../domain/models/dto/WorkDTO";
import AlarmIconSVG from "../../svg/AlarmIconSVG";
import { getNormalizedExpiresIn } from "../../../../tools/DatetimeTools";
import { MILLISECONDS_IN_MINUTE } from "../../../../domain/constants";
import { differenceInMilliseconds, isPast, subMilliseconds } from "date-fns";

interface ExpiresInTimerLabelProps {
    work: WorkDTO;
    biggerVersion?: boolean;
}

const ExpiresInTimerLabel: FC<ExpiresInTimerLabelProps> = (props) => {
    const [expiresIn, setExpiresIn] = useState(new Date(props.work.expiresIn));

    useEffect(() => {
        const timeout = setInterval(() => {
            setExpiresIn(() => {
                const newDate = subMilliseconds(
                    new Date(),
                    differenceInMilliseconds(new Date(), new Date(props.work.expiresIn))
                );
                if (!isPast(newDate)) {
                    return newDate;
                }
                clearInterval(timeout);
            });
        }, MILLISECONDS_IN_MINUTE);
        return () => clearInterval(timeout);
    }, []);

    if (!isExpressWork(props.work) || !expiresIn || isPast(expiresIn)) {
        return <></>;
    }

    return (
        <>
            {props.biggerVersion ? (
                <div className="flex items-center justify-center gap-2 dmax2:gap-1.5 bg-textWarning rounded-[30px] h-[38px] dmax2:h-6 px-9 dmax2:px-5">
                    <AlarmIconSVG className="w-[23px] dmax2:w-4 h-[23px] dmax2:h-4 text-textWhite" />
                    <span className="H16B dmax2:H14B text-textWhite">{getNormalizedExpiresIn(expiresIn)}</span>
                </div>
            ) : (
                <div className="flex items-center justify-center gap-2 dmax2:gap-1.5 bg-textWarning rounded-[30px] h-[30px] dmax2:h-6 px-7 dmax2:px-5">
                    <AlarmIconSVG className="w-[23px] dmax2:w-4 h-[23px] dmax2:h-4 text-textWhite" />
                    <span className="H16B dmax2:H14B text-textWhite">{getNormalizedExpiresIn(expiresIn)}</span>
                </div>
            )}
        </>
    );
};

export default ExpiresInTimerLabel;
